import React from 'react'
import CHARKAOUI_Wijdane from './CHARKAOUI_Wijdane.png'
export default function 
() {
  return (
    <div className='Home'>
        <div className='nullDiv'></div>
        <div className='imageDiv'><img src={CHARKAOUI_Wijdane}/></div>
        <p className='myName'>Wijdane CHARKAOUI</p>
        <p className='paragraph'>
            AN ENGINEERING STUDENT IN COMPUTER SCIENCE
            <br></br>
            A FRONT-END PROFILE
            <br></br>
            LEARN MORE ABOUT WHAT I DO
        </p>
    </div>
  )
}
